import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=71535bc8&scoped=true&"
import script from "./Update.js?vue&type=script&lang=js&"
export * from "./Update.js?vue&type=script&lang=js&"
import style0 from "./Update.scss?vue&type=style&index=0&id=71535bc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71535bc8",
  null
  
)

export default component.exports